import React from 'react';
import {
  Box,
  Skeleton
} from '@mui/material';

interface RegistrationSkeletonProps {
  fieldCount: number;
  currentStep: number;
}

export const RegistrationSkeleton: React.FC<RegistrationSkeletonProps> = ({
  fieldCount,
  currentStep
}) => {
  return (
    <Box sx={{ py: 2 }} data-testid="loading-skeleton">
      <Box sx={{ mb: 3 }}>
        <Skeleton
          variant="text"
          height={32}
          sx={{
            width: { xs: '80%', md: '60%' },
            fontSize: '1.25rem',
            transform: 'none',
            borderRadius: 1
          }}
        />
      </Box>

      <Box sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: '1fr',
          md: 'repeat(2, 1fr)'
        },
        gap: { xs: 2, md: 3 },
        mb: 4
      }}>
        {Array.from({ length: fieldCount }, (_, i) => (
          <Box key={i} sx={{ minHeight: '72px' }}>
            <Skeleton
              variant="rounded"
              height={56}
              sx={{
                borderRadius: 1,
                transform: 'none'
              }}
            />
            <Skeleton
              variant="text"
              height={16}
              width={i % 2 === 0 ? '70%' : '45%'}
              sx={{
                mt: 0.5,
                fontSize: '0.75rem',
                transform: 'none',
                borderRadius: 0.5
              }}
            />
          </Box>
        ))}
      </Box>

      <Box sx={{
        display: { xs: 'none', md: 'flex' },
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 2
      }}>
        {(currentStep || 0) > 0 && (
          <Skeleton
            variant="rounded"
            width={120}
            height={36}
            sx={{ borderRadius: 1, transform: 'none' }}
          />
        )}
        <Box sx={{ flexGrow: 1 }} />
        <Skeleton
          variant="rounded"
          width={(currentStep || 0) === 0 ? '100%' : 140}
          height={36}
          sx={{
            borderRadius: 1,
            transform: 'none',
            ml: (currentStep || 0) > 0 ? 2 : 0
          }}
        />
      </Box>
    </Box>
  );
};
